<template>
  <div class="card h-100 px-3 py-2">
    <b-row v-if="!!filteredSchedule" class="mb-4">
      <b-col>
        <b-dropdown size="sm" variant="outline-primary">
          <template #button-content>
            <span>
              <i class="fa fa-fw fa-filter"></i>
              {{ !!selectedTeam ? selectedTeam.name : trans('team') }}
            </span>
          </template>
          <b-dropdown-item @click="selectedTeam = null">
            {{ trans('all') }}
          </b-dropdown-item>
          <b-dropdown-item
              v-for="(team, index) in teams"
              v-bind:key="index"
              @click="selectedTeam = team"
          >
            {{ team.name }}
          </b-dropdown-item>
        </b-dropdown>
        <b-button variant="outline-success" size="sm" class="ml-2" :disabled="!selectedTeam" v-b-modal.team-calendar-modal>
          <i class="fa fa-fw fa-calendar"></i>
          {{ trans('calendar') }}
        </b-button>
      </b-col>
    </b-row>
    <div v-if="!!block && !!block.text" v-html="block.text"></div>
    <table :class="`table table-responsive-md table-no-top-border table-sm my-2`">
      <thead>
        <tr>
          <th role="columnheader">{{ trans('game_round') }}</th>
          <th role="columnheader">{{ trans('date') }}</th>
          <th role="columnheader" class="text-right">{{ trans('game_home') }}</th>
          <th role="columnheader"></th>
          <th role="columnheader">{{ trans('game_away') }}</th>
          <th role="columnheader">{{ trans('field') }}</th>
        </tr>
      </thead>
      <tbody v-if="!!filteredSchedule">
        <tr v-for="(item, index) in filteredSchedule" :key="index">
          <td class="align-middle">{{ item.round }}</td>
          <td class="align-middle">
            <strong class="d-none d-md-block">
              {{ moment(item.start).format('MMMM D') }} - {{ moment(item.start).format('dddd') }}
            </strong>
            <small class="d-block d-md-none font-weight-bold">
              {{ moment(item.start).format('MMMM D') }} - {{ moment(item.start).format('dddd') }}
            </small>
            <small class="d-block">{{ moment(item.start).format('LT') }}</small>
          </td>
          <td class="align-top text-right">
            <span class="d-none d-md-inline">{{ item.home_team_name }}</span>
            <img v-if="!!item.home_team_image_url" :src="item.home_team_image_url" style="max-height: 40px;" />
            <span v-if="!item.home_team_image_url" class="h3"><i class="fa fa-fw fa-tshirt text-muted"></i></span>
            <small class="d-md-none d-block">{{ item.home_team_name }}</small>
          </td>
          <td class="align-middle">
            <div v-if="isNumeric(item.home_team_goals) || isNumeric(item.away_team_goals)" class="px-1 mx-1 lead text-center bg-primary text-light border-light">
              <strong>
                {{  item.home_team_goals || 0 }}
              </strong>
              -
              <strong>
                {{ item.away_team_goals || 0 }}
              </strong>
            </div>
            <div v-if="!isNumeric(item.home_team_goals) && !isNumeric(item.away_team_goals)" class="px-1 mx-1 lead text-center border">
              <strong>&nbsp;</strong>
              &nbsp;
              <strong>&nbsp;</strong>
            </div>
          </td>
          <td class="align-top">
            <img v-if="!!item.away_team_image_url" :src="item.away_team_image_url" style="max-height: 40px;" />
            <span v-if="!item.away_team_image_url" class="h3"><i class="fa fa-fw fa-tshirt text-muted"></i></span>
            <span class="d-none d-md-inline">{{ item.away_team_name }}</span>
            <small class="d-md-none d-block">{{ item.away_team_name }}</small>
          </td>
          <td class="align-middle">
            <span class="d-none d-md-inline">{{ (item.location_alias || item.location_name) }}</span>
            <small class="d-md-none d-block">{{ (item.location_alias || item.location_name) }}</small>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!!block && !!block.text2" v-html="block.text2"></div>
    <TeamCalendarModal
      :organization="organization"
      :page="page"
      :block="block"
      :team="selectedTeam"
    />
  </div>
</template>
<style>
@media screen and (max-width: 767px) {
  .add-to-cal {
    width: 100% !important;
  }
}
</style>
<script>
  import TeamCalendarModal from './TeamCalendarModal.vue'
  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      isPreview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        isNumeric: _.isNumeric,
        currency: _.currency,
        schedule: null,
        teams: [],
        selectedTeam: null,
      }
    },
    components: {
      TeamCalendarModal
    },
    computed: {
      filteredSchedule() {
        if (!this.selectedTeam) return this.schedule
        return _.reduce(this.schedule || [], (schedule, s) => {
          if (s.home_team_id == this.selectedTeam.id || s.away_team_id == this.selectedTeam.id) {
            schedule.push(s)
          }
          return schedule
        }, [])
      },
    },
    watch: {
      block() {
        this.fetch()
      },
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        if (this.isPreview) {
          let url = `/organization/${this.organization.id}/page/${this.page.id}/simulate_teams_schedule`
          axios.post(url, this.block)
          .then(response => {
            this.busy = false
            this.schedule = response.data
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        } else {
          let slug = (this.page.slug || '').replace('/', '') || 'undefined'
          let url = `/org/${this.organization.id}/page/${this.page.upid}/${slug}/teams/${this.block.id}/schedule`
          axios.get(url)
          .then(response => {
            this.busy = false
            this.schedule = response.data
            this.schedule.map((item) => {
              if (this.teams.find((team) => team.id == item.away_team_id) == undefined) {
                this.teams.push({
                  name: item.away_team_name,
                  id: item.away_team_id
                })
              }

              if (this.teams.find((team) => team.id == item.home_team_id) == undefined) {
                this.teams.push({
                  name: item.home_team_name,
                  id: item.home_team_id
                })
              }
            })

            this.teams.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        }
      },
    },
    mounted() {
      window['pageTeamsSchedule'+(!!this.block ? this.block.id || '' : '')] = this
      this.fetch()
    },
  }
</script>